import { A, pipe } from '@mobily/ts-belt'
import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore, sample } from 'effector'
import {
  CategoryId,
  type TvCategoryEx,
  allCategory,
  favoriteCategory,
} from './index.h'
import { toRegularType } from './lib'

// all loaded categories
export const $loaded = createStore<TvCategoryEx[]>([])

// made-up categories (like "All", "Favorites")
export const $madeup = createStore<TvCategoryEx[]>([
  favoriteCategory,
  allCategory,
])

// remove made-up category
export const removeMadeupCategory = createEvent<CategoryId | number>()

// remove "Favorite" made-up category
export const removeFavoriteCategory = removeMadeupCategory.prepend(
  () => CategoryId.Favorite
)

// load categories
export const loadPageFx = api.live.base.getLiveChannelsCategoriesFx

// Store that tracks the regionId of the most recently loaded categories and channels
export const $regionId = createStore<number | null>(null)

sample({
  clock: loadPageFx.done,
  fn: ({ params }) => {
    return params?.regionId
  },
  target: $regionId,
})

// when categories are loaded - attach the type to the category
sample({
  clock: loadPageFx.doneData,
  fn: (content) => {
    return pipe(content, A.map(toRegularType))
  },
  target: $loaded,
})

// remove any made-up category
sample({
  clock: removeMadeupCategory,
  source: $madeup,
  fn: (madeup, toRemoveId) => A.reject(madeup, ({ id }) => id === toRemoveId),
  target: $madeup,
})

export const $allCategories = combine($madeup, $loaded, (madeup, loaded) => [
  ...madeup,
  ...loaded,
])
